import template from './socialSecurityModal.html';
import './socialSecurityModal.scss';

let socialSecurityModalComponent = {
  restrict: 'E',
  bindings: {
    errorMsg: '<',
  },
  template
};

export default socialSecurityModalComponent;



// WEBPACK FOOTER //
// ./client/app/social-security.module/components/socialSecurityModal/socialSecurityModal.component.js